import { IonItem, IonLabel, IonInput, IonButton, IonToast } from "@ionic/react";

import { Controller, useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

import InputErrorMessage from "../../../components/InputErrorMessage";
import { createProfile } from "../../../store/profileForm/actions/createProfile";
import { resetFormProfile } from "../../../store/profileForm/profileForm.reducer";

import { FormButtonSubmit } from "./FormButtonSubmit";
import {useMemo} from "react";

export const CreateProfileForm: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: {
      name: "",
      description: "",
    },
  });
  const onSubmit = async (data: any) => {
    try {
      const { payload }: any = await dispatch(createProfile(data));

      history.push(`/app/tic/perfiles/detalle/${payload.id}`);
      dispatch(resetFormProfile());
    } catch (error) {
      console.log(error);
    }
  };

  const controllers = useMemo(()=>{
    return [({ field: { onChange, value } }:any) => (
      <IonInput
        onIonChange={(e) => onChange(e.detail.value)}
        value={value}
        {...register("name", {
          required: "Campo obligatorio.",
        })}
      ></IonInput>
    ),({ field: { onChange, value } }:any) => (
      <IonInput
        onIonChange={(e) => onChange(e.detail.value)}
        value={value}
        {...register("description", {
          required: "Campo obligatorio.",
        })}
      ></IonInput>
    )]
  },[])

  return (
    <form onSubmit={handleSubmit(onSubmit)} style={{ padding: 18 }} noValidate>
      <IonItem lines="inset">
        <IonLabel position="stacked">Nombre</IonLabel>
        <Controller
          control={control}
          name="name"
          render={controllers[0]}
        />
      </IonItem>
      <InputErrorMessage errorMessage={errors.name?.message || ""} paddingLeft={15} />

      <IonItem lines="inset">
        <IonLabel position="stacked">Descripción</IonLabel>
        <Controller
          control={control}
          name="description"
          render={controllers[1]}
        />
      </IonItem>
      <InputErrorMessage errorMessage={errors.description?.message || ""} paddingLeft={15} />
      <FormButtonSubmit />
    </form>
  );
};
